export default __webpack_public_path__ + "static/media/francheville03.8b171280.jpg";